import { ReportRecommendationsModel } from '@/types/report/ReportRecommendationsModel';
import { buildAPIUrl, responseInterceptor } from '.';
import { CognitiveFilterRequestModel, CognitiveSearchResultModel, ReportSearchModel } from '@/types';
import { ReportAutocompleteModel } from '@/types/report/ReportAutocompleteModel';

export const searchReports = async (
  filterRequest: CognitiveFilterRequestModel,
): Promise<CognitiveSearchResultModel<ReportSearchModel>> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ReportListing/SearchReports`, {
      method: 'POST',
      body: JSON.stringify(filterRequest),
    }),
  );

  return response.json();
};

export const reportRecommendations = async (userId: string): Promise<ReportRecommendationsModel> => {
  const params = new URLSearchParams({
    userId,
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ReportListing/Recommendations?${params.toString()}`),
  );

  return response.json();
};

export const reportAutocomplete = async (searchTerm: string): Promise<ReportAutocompleteModel> => {
  const params = new URLSearchParams({
    searchTerm,
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ReportListing/Autocomplete?${params.toString()}`),
  );

  return response.json();
};
